// import React, { useState, useEffect, useCallback } from "react";
// import {
//     Box, Typography, TextField, InputAdornment, Tooltip,
//     CircularProgress,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
// import StarIcon from "@mui/icons-material/Star";
// import StarBorderIcon from "@mui/icons-material/StarBorder";
// import { useAuth } from '../context/AuthContext';

// import LedgerDetails from "./LedgerDetails";
// import StockReport from "./StockReport";
// import OSandODSaleReport from "./OSandODSaleReport";
// import OSandODPurcReport from "./OSandODPurcReport";
// import MISReports from "./MISReports";

// // ── Design tokens ─────────────────────────────────────────────────────────────
// const NAVY = "#0D2137";
// const STEEL = "#1B4FBB";
// const STEEL_LT = "#EBF2FF";
// const PAGE_BG = "#F4F6F9";
// const CARD = "#FFFFFF";
// const BORDER = "#E2E8F0";
// const TH_BG = "#F7F9FC";
// const FAV_BG = "#FFFBEA";
// const FAV_BORD = "#F6C90E33";
// const T1 = "#1A202C";
// const T2 = "#4A5568";
// const T3 = "#718096";
// const WHITE = "#FFFFFF";
// const STAR_COLOR = "#F6C90E";

// const SIDEBAR_W = 248;
// const MAX_STARS = 10;

// // ── Report groups ─────────────────────────────────────────────────────────────
// const REPORT_GROUPS = [
//     {
//         id: "ledger",
//         header: "Ledger Reports",
//         items: [
//             { id: "general_ledger", label: "General Ledger", component: "LedgerDetails" },
//             { id: "bankbook", label: "BankBook", component: "LedgerDetails" },
//             { id: "cashbook", label: "CashBook", component: "LedgerDetails" },
//             { id: "daybook", label: "DayBook", component: "LedgerDetails" },
//             { id: "groupwise_summary", label: "Groupwise Summary", component: "LedgerDetails" },
//         ],
//     },
//     {
//         id: "stock",
//         header: "Stock Reports",
//         items: [
//             { id: "general_stock", label: "General Stock Report", component: "StockReport" },
//             { id: "average_rate", label: "Average Rate", component: "StockReport" },
//             { id: "purchase_rate", label: "Purchase Rate", component: "StockReport" },
//             { id: "last_purchase_rate", label: "Last Purchase Rate", component: "StockReport" },
//             { id: "min_level", label: "Min Level", component: "StockReport" },
//             { id: "max_level", label: "Max Level", component: "StockReport" },
//             { id: "groupwise_item", label: "Groupwise Item", component: "StockReport" },
//         ],
//     },
//     {
//         id: "os_od_sale",
//         header: "O/S & O/D Sale",
//         items: [
//             { id: "sale_outstanding", label: "Sale Outstanding Bills", component: "OSandODSaleReport" },
//             { id: "sale_overdue", label: "Sale Overdue Bills", component: "OSandODSaleReport" },
//         ],
//     },
//     {
//         id: "os_od_purc",
//         header: "O/S & O/D Purc",
//         items: [
//             { id: "purchase_outstanding", label: "Purchase Outstanding Bills", component: "OSandODPurcReport" },
//             { id: "purchase_overdue", label: "Purchase Overdue Bills", component: "OSandODPurcReport" },
//         ],
//     },
//     {
//         id: "mis_sale",
//         header: "MIS Sale Reports",
//         items: [
//             { id: "mis_itemwise_sale", label: "ItemWise Sales", component: "MISReports" },
//             { id: "mis_partywise_itemwise_sale", label: "Partywise/Itemwise Sale", component: "MISReports" },
//             { id: "mis_itemwise_partywise_sale", label: "Itemwise/Partywise Sale", component: "MISReports" },
//             { id: "mis_citywise_itemwise_sale", label: "Citywise/Itemwise Sale", component: "MISReports" },
//             { id: "mis_itemwise_citywise_sale", label: "Itemwise/Citywise Sale", component: "MISReports" },
//             { id: "mis_agentwise_itemwise_sale", label: "Agentwise/Itemwise Sale", component: "MISReports" },
//             { id: "mis_itemwise_agentwise_sale", label: "Itemwise/Agentwise Sale", component: "MISReports" },
//             { id: "mis_partywise_citywise_sale", label: "Partywise/Citywise Sale", component: "MISReports" },
//             { id: "mis_citywise_partywise_sale", label: "Citywise/Partywise Sale", component: "MISReports" },
//         ],
//     },
//     {
//         id: "mis_purchase",
//         header: "MIS Purchase Reports",
//         items: [
//             { id: "mis_itemwise_purchase", label: "ItemWise Purchase", component: "MISReports" },
//             { id: "mis_partywise_itemwise_purchase", label: "Partywise/Itemwise Purchase", component: "MISReports" },
//             { id: "mis_itemwise_partywise_purchase", label: "Itemwise/Partywise Purchase", component: "MISReports" },
//             { id: "mis_citywise_itemwise_purchase", label: "Citywise/Itemwise Purchase", component: "MISReports" },
//             { id: "mis_itemwise_citywise_purchase", label: "Itemwise/Citywise Purchase", component: "MISReports" },
//             { id: "mis_agentwise_itemwise_purchase", label: "Agentwise/Itemwise Purchase", component: "MISReports" },
//             { id: "mis_itemwise_agentwise_purchase", label: "Itemwise/Agentwise Purchase", component: "MISReports" },
//             { id: "mis_partywise_citywise_purchase", label: "Partywise/Citywise Purchase", component: "MISReports" },
//             { id: "mis_citywise_partywise_purchase", label: "Citywise/Partywise Purchase", component: "MISReports" },
//         ],
//     },
// ];

// // ── Flat lookup map by ReportId (item.id) ─────────────────────────────────────
// const ALL_ITEMS_MAP = {};
// REPORT_GROUPS.forEach(g =>
//     g.items.forEach(item => { ALL_ITEMS_MAP[item.id] = item; })
// );

// // ── Empty state ───────────────────────────────────────────────────────────────
// function EmptyState() {
//     return (
//         <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 4, background: PAGE_BG }}>
//             <Box sx={{ textAlign: "center", maxWidth: 380 }}>
//                 <Box sx={{ width: 64, height: 64, borderRadius: "16px", background: STEEL_LT, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
//                     <AssessmentOutlinedIcon sx={{ fontSize: 32, color: STEEL }} />
//                 </Box>
//                 <Typography sx={{ fontSize: 16, fontWeight: 700, color: T1, mb: 1 }}>Select a Report</Typography>
//                 <Typography sx={{ fontSize: 13, color: T3, lineHeight: 1.7 }}>
//                     Choose any report from the sidebar on the left to view it and configure its filters.
//                 </Typography>
//             </Box>
//         </Box>
//     );
// }

// // ── Reusable Report Row ───────────────────────────────────────────────────────
// function ReportRow({ item, isActive, isStarred, starLoading, onSelect, onToggleStar }) {
//     return (
//         <Box
//             onClick={() => onSelect(item)}
//             sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 pl: 2,
//                 pr: 0.5,
//                 py: "7px",
//                 cursor: "pointer",
//                 background: isActive ? STEEL_LT : "transparent",
//                 borderLeft: `3px solid ${isActive ? STEEL : "transparent"}`,
//                 borderBottom: `1px solid ${BORDER}`,
//                 transition: "background 0.12s",
//                 "& .star-btn": {
//                     opacity: isStarred ? 1 : 0,
//                     transition: "opacity 0.15s",
//                 },
//                 "&:hover": {
//                     background: isActive ? STEEL_LT : "#F1F5FF",
//                     "& .star-btn": { opacity: 1 },
//                 },
//             }}
//         >
//             <BarChartIcon sx={{ fontSize: 12, color: isActive ? STEEL : T3, flexShrink: 0 }} />
//             <Typography
//                 sx={{
//                     flex: 1,
//                     fontSize: 12,
//                     color: isActive ? STEEL : T2,
//                     fontWeight: isActive ? 600 : 400,
//                     lineHeight: 1.35,
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     whiteSpace: "nowrap",
//                 }}
//             >
//                 {item.label}
//             </Typography>
//             <Tooltip
//                 title={isStarred ? "Remove from favourites" : "Add to favourites"}
//                 placement="right"
//             >
//                 <Box
//                     className="star-btn"
//                     onClick={(e) => { e.stopPropagation(); onToggleStar(item); }}
//                     sx={{
//                         flexShrink: 0,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         width: 22,
//                         height: 22,
//                         borderRadius: "4px",
//                         cursor: starLoading ? "not-allowed" : "pointer",
//                         "&:hover": { background: "rgba(246,201,14,0.15)" },
//                     }}
//                 >
//                     {starLoading && isStarred === undefined ? (
//                         <CircularProgress size={10} sx={{ color: T3 }} />
//                     ) : isStarred ? (
//                         <StarIcon sx={{ fontSize: 13, color: STAR_COLOR }} />
//                     ) : (
//                         <StarBorderIcon sx={{ fontSize: 13, color: T3 }} />
//                     )}
//                 </Box>
//             </Tooltip>
//         </Box>
//     );
// }

// // ── Main component ────────────────────────────────────────────────────────────
// export default function AccountReports({
//     connectionString,
//     pdfString,
// }) {
//     const API_URL = connectionString;
//     const { user, selectedCompany } = useAuth();
//     const CompID = selectedCompany?.CompId;
//     const AppRegID = selectedCompany?.AppRegID || null;
//     const userId = user.UserId;

//     const [sidebarOpen, setSidebarOpen] = useState(true);
//     const [searchText, setSearchText] = useState("");
//     const [activeReport, setActiveReport] = useState(null);

//     const [starredItems, setStarredItems] = useState([]);
//     const [starLoading, setStarLoading] = useState(false);
//     const [favLoading, setFavLoading] = useState(true);

//     // Derived O(1) lookup by item.id (ReportId)
//     const starredIds = new Set(starredItems.map(i => i.id));

//     // ── Load favourites on mount ──────────────────────────────────────────────
//     useEffect(() => {
//         if (!userId || !CompID) {
//             setFavLoading(false);
//             return;
//         }

//         // ── Only send AppRegID, CompID, UserId as query params ────────────────
//         const params = new URLSearchParams({
//             UserId: userId,
//             CompID: CompID,
//             AppRegID: AppRegID ?? 0,
//         });

//         fetch(`${API_URL}/api/getFavouriteReports?${params}`)
//             .then(res => {
//                 if (!res.ok) throw new Error("Failed to load favourites");
//                 return res.json();
//             })
//             .then(({ success, data }) => {
//                 if (!success) throw new Error("API returned success: false");

//                 // Map DB rows → sidebar item shape using ReportId as key
//                 const items = (data || [])
//                     .map(row => {
//                         const found = ALL_ITEMS_MAP[row.ReportId];
//                         if (!found) return null;
//                         return { ...found, SrNo: row.SrNo };
//                     })
//                     .filter(Boolean)
//                     .sort((a, b) => a.SrNo - b.SrNo);

//                 setStarredItems(items);
//             })
//             .catch((err) => {
//                 console.error("Load favourites error:", err);
//             })
//             .finally(() => setFavLoading(false));
//     }, [API_URL, userId, CompID, AppRegID]);

//     // ── Toggle star ───────────────────────────────────────────────────────────
//     const toggleStar = useCallback(async (item) => {
//         if (starLoading) return;

//         const alreadyStarred = starredIds.has(item.id);

//         if (!alreadyStarred && starredItems.length >= MAX_STARS) {
//             return;
//         }

//         setStarLoading(true);

//         try {
//             // ── Only send AppRegID, CompID, UserId and ReportId ───────────────
//             // ── CompID is stored in BOTH CompID and GCompID on the backend ────
//             const requestBody = {
//                 AppRegID: AppRegID ?? 0,
//                 CompID: CompID ?? 0,
//                 UserId: userId ?? 0,
//                 ReportId: item.id,           // e.g. "mis_itemwise_sale"
//                 ReportLabel: item.label,        // e.g. "ItemWise Sales"
//             };

//             console.log("Toggle star request:", {
//                 action: alreadyStarred ? "DELETE" : "ADD",
//                 body: requestBody,
//             });

//             if (alreadyStarred) {
//                 // ── REMOVE ────────────────────────────────────────────────────
//                 const res = await fetch(`${API_URL}/api/deleteFavouriteReport`, {
//                     method: "DELETE",
//                     headers: { "Content-Type": "application/json" },
//                     body: JSON.stringify(requestBody),
//                 });

//                 const json = await res.json();
//                 if (!res.ok || !json.success) {
//                     throw new Error(json.message || "Remove failed");
//                 }

//                 setStarredItems(prev => prev.filter(i => i.id !== item.id));

//             } else {
//                 // ── ADD ───────────────────────────────────────────────────────
//                 const res = await fetch(`${API_URL}/api/addFavouriteReport`, {
//                     method: "POST",
//                     headers: { "Content-Type": "application/json" },
//                     body: JSON.stringify(requestBody),
//                 });

//                 const json = await res.json();
//                 if (!res.ok || !json.success) {
//                     throw new Error(json.message || "Add failed");
//                 }

//                 setStarredItems(prev => [
//                     ...prev,
//                     { ...item, SrNo: json.SrNo ?? prev.length + 1 },
//                 ]);
//             }
//         } catch (err) {
//             console.error("Toggle star error:", err);
//         } finally {
//             setStarLoading(false);
//         }
//     }, [API_URL, starLoading, starredIds, starredItems, userId, CompID, AppRegID]);

//     // ── Filter groups by search ───────────────────────────────────────────────
//     const filteredGroups = searchText.trim()
//         ? REPORT_GROUPS
//             .map(g => ({
//                 ...g,
//                 items: g.items.filter(item =>
//                     item.label.toLowerCase().includes(searchText.toLowerCase())
//                 ),
//             }))
//             .filter(g => g.items.length > 0)
//         : REPORT_GROUPS;

//     // ── Filter favourites by search ───────────────────────────────────────────
//     const filteredFavourites = searchText.trim()
//         ? starredItems.filter(item =>
//             item.label.toLowerCase().includes(searchText.toLowerCase())
//         )
//         : starredItems;

//     // ── Render selected report ────────────────────────────────────────────────
//     const renderContent = () => {
//         if (!activeReport) return <EmptyState />;
//         const props = { connectionString, pdfString };
//         switch (activeReport.component) {
//             case "LedgerDetails": return <LedgerDetails key="LedgerDetails"     {...props} />;
//             case "StockReport": return <StockReport key="StockReport"       {...props} />;
//             case "OSandODSaleReport": return <OSandODSaleReport key="OSandODSaleReport" {...props} />;
//             case "OSandODPurcReport": return <OSandODPurcReport key="OSandODPurcReport" {...props} />;
//             case "MISReports": return <MISReports key="MISReports"        {...props} />;
//             default: return <EmptyState />;
//         }
//     };

//     return (
//         <Box
//             sx={{
//                 display: "flex",
//                 height: "93vh",
//                 maxHeight: "93vh",
//                 background: PAGE_BG,
//                 overflow: "hidden",
//             }}
//         >
//             {/* ── SIDEBAR WRAPPER ── */}
//             <Box
//                 sx={{
//                     position: "relative",
//                     flexShrink: 0,
//                     overflow: "visible",
//                     zIndex: 10,
//                     height: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                 }}
//             >
//                 {/* ── Sidebar panel ── */}
//                 <Box
//                     sx={{
//                         width: sidebarOpen ? SIDEBAR_W : 0,
//                         height: "100%",
//                         background: CARD,
//                         borderRight: `1px solid ${BORDER}`,
//                         display: "flex",
//                         flexDirection: "column",
//                         overflow: "hidden",
//                         transition: "width 0.22s ease",
//                     }}
//                 >
//                     {/* Fixed header */}
//                     <Box sx={{ background: NAVY, px: 2, pt: 1.5, pb: 1.5, flexShrink: 0 }}>
//                         <Typography
//                             sx={{
//                                 fontSize: 12, fontWeight: 700, color: WHITE,
//                                 mb: 1, letterSpacing: ".5px", textTransform: "uppercase",
//                             }}
//                         >
//                             Account Reports
//                         </Typography>
//                         <TextField
//                             size="small"
//                             fullWidth
//                             placeholder="Search reports…"
//                             value={searchText}
//                             onChange={(e) => setSearchText(e.target.value)}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.45)" }} />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                             sx={{
//                                 "& .MuiOutlinedInput-root": {
//                                     background: "rgba(255,255,255,0.08)",
//                                     borderRadius: "4px",
//                                     fontSize: 12,
//                                     color: WHITE,
//                                     height: 30,
//                                     "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
//                                     "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
//                                     "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,0.55)", borderWidth: 1 },
//                                     "& input": { py: 0 },
//                                     "& input::placeholder": { color: "rgba(255,255,255,0.4)", opacity: 1 },
//                                 },
//                             }}
//                         />
//                     </Box>

//                     {/* ── Scrollable list ── */}
//                     <Box
//                         sx={{
//                             flex: 1,
//                             minHeight: 0,
//                             overflowY: "auto",
//                             overflowX: "hidden",
//                             "&::-webkit-scrollbar": { width: 4 },
//                             "&::-webkit-scrollbar-track": { background: "transparent" },
//                             "&::-webkit-scrollbar-thumb": { background: BORDER, borderRadius: 4 },
//                             "&::-webkit-scrollbar-thumb:hover": { background: T3 },
//                         }}
//                     >
//                         {favLoading && (
//                             <Box sx={{ px: 2, py: 2, display: "flex", alignItems: "center", gap: 1 }}>
//                                 <CircularProgress size={12} sx={{ color: STAR_COLOR }} />
//                                 <Typography sx={{ fontSize: 11, color: T3 }}>Loading favourites…</Typography>
//                             </Box>
//                         )}

//                         {/* ════════════════════════════════════════════════════
//                             FAVOURITES SECTION
//                         ════════════════════════════════════════════════════ */}
//                         {!favLoading && filteredFavourites.length > 0 && (
//                             <Box>
//                                 <Box
//                                     sx={{
//                                         px: 1.5, py: "6px",
//                                         background: FAV_BG,
//                                         borderBottom: `1px solid ${FAV_BORD}`,
//                                         userSelect: "none",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: 0.5,
//                                     }}
//                                 >
//                                     <StarIcon sx={{ fontSize: 10, color: STAR_COLOR }} />
//                                     <Typography
//                                         sx={{
//                                             fontSize: 10, fontWeight: 700, color: "#B8860B",
//                                             textTransform: "uppercase", letterSpacing: ".8px",
//                                         }}
//                                     >
//                                         Favourites
//                                         <Box
//                                             component="span"
//                                             sx={{
//                                                 ml: 0.8, px: "5px", py: "1px",
//                                                 fontSize: 9, fontWeight: 700,
//                                                 background: STAR_COLOR, color: NAVY,
//                                                 borderRadius: "8px", verticalAlign: "middle",
//                                             }}
//                                         >
//                                             {starredItems.length}/{MAX_STARS}
//                                         </Box>
//                                     </Typography>
//                                 </Box>

//                                 {filteredFavourites.map(item => (
//                                     <ReportRow
//                                         key={`fav-${item.id}`}
//                                         item={item}
//                                         isActive={activeReport?.id === item.id}
//                                         isStarred={true}
//                                         starLoading={starLoading}
//                                         onSelect={setActiveReport}
//                                         onToggleStar={toggleStar}
//                                     />
//                                 ))}

//                                 <Box sx={{ height: 4, background: FAV_BG, borderBottom: `1px solid ${FAV_BORD}` }} />
//                             </Box>
//                         )}

//                         {/* ════════════════════════════════════════════════════
//                             REGULAR REPORT GROUPS
//                         ════════════════════════════════════════════════════ */}
//                         {filteredGroups.map((group, gIdx) => (
//                             <Box key={group.id}>
//                                 <Box
//                                     sx={{
//                                         px: 1.5, py: "6px",
//                                         background: TH_BG,
//                                         borderBottom: `1px solid ${BORDER}`,
//                                         borderTop: gIdx === 0 && filteredFavourites.length === 0
//                                             ? "none"
//                                             : `1px solid ${BORDER}`,
//                                         userSelect: "none",
//                                     }}
//                                 >
//                                     <Typography
//                                         sx={{
//                                             fontSize: 10, fontWeight: 700, color: STEEL,
//                                             textTransform: "uppercase", letterSpacing: ".8px",
//                                         }}
//                                     >
//                                         {group.header}
//                                     </Typography>
//                                 </Box>

//                                 {group.items.map(item => (
//                                     <ReportRow
//                                         key={item.id}
//                                         item={item}
//                                         isActive={activeReport?.id === item.id}
//                                         isStarred={starredIds.has(item.id)}
//                                         starLoading={starLoading}
//                                         onSelect={setActiveReport}
//                                         onToggleStar={toggleStar}
//                                     />
//                                 ))}
//                             </Box>
//                         ))}

//                         {!favLoading && filteredGroups.length === 0 && filteredFavourites.length === 0 && (
//                             <Box sx={{ px: 2, py: 3, textAlign: "center" }}>
//                                 <SearchIcon sx={{ fontSize: 22, color: BORDER, display: "block", mx: "auto", mb: 0.5 }} />
//                                 <Typography sx={{ fontSize: 12, color: T3 }}>No reports found</Typography>
//                             </Box>
//                         )}
//                     </Box>
//                 </Box>

//                 {/* ── TOGGLE TAB ── */}
//                 <Tooltip title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"} placement="right">
//                     <Box
//                         onClick={() => setSidebarOpen(v => !v)}
//                         sx={{
//                             position: "absolute",
//                             right: -14,
//                             top: "50%",
//                             transform: "translateY(-50%)",
//                             width: 14,
//                             height: 52,
//                             background: NAVY,
//                             borderRadius: "0 6px 6px 0",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             cursor: "pointer",
//                             zIndex: 30,
//                             boxShadow: "2px 2px 6px rgba(0,0,0,0.18)",
//                             transition: "background 0.14s",
//                             "&:hover": { background: STEEL },
//                         }}
//                     >
//                         {sidebarOpen
//                             ? <ChevronLeftIcon sx={{ fontSize: 13, color: WHITE }} />
//                             : <ChevronRightIcon sx={{ fontSize: 13, color: WHITE }} />
//                         }
//                     </Box>
//                 </Tooltip>
//             </Box>

//             {/* ── MAIN CONTENT AREA ── */}
//             <Box
//                 sx={{
//                     flex: 1,
//                     minWidth: 0,
//                     minHeight: 0,
//                     display: "flex",
//                     flexDirection: "column",
//                     overflow: "hidden",
//                 }}
//             >
//                 {renderContent()}
//             </Box>
//         </Box>
//     );
// }






import React, { useState, useEffect, useCallback } from "react";
import {
    Box, Typography, TextField, InputAdornment, Tooltip,
    CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useAuth } from '../context/AuthContext';

import LedgerDetails from "./LedgerDetails";
import StockReport from "./StockReport";
import OSandODSaleReport from "./OSandODSaleReport";
import OSandODPurcReport from "./OSandODPurcReport";
import MISReports from "./MISReports";
import MISPurchaseReports from "./MISPurchaseReports";
import GSTReports from "./GSTReports";
import DepreciationReport from "./DepreciationReport";
import InterestCalculationReport from "./InterestCalculationReport";
import BalanceSheetReport from "./BalanceSheetReport";

// ── Design tokens ─────────────────────────────────────────────────────────────
const NAVY = "#0D2137";
const STEEL = "#1B4FBB";
const STEEL_LT = "#EBF2FF";
const PAGE_BG = "#F4F6F9";
const CARD = "#FFFFFF";
const BORDER = "#E2E8F0";
const TH_BG = "#F7F9FC";
const FAV_BG = "#FFFBEA";
const FAV_BORD = "#F6C90E33";
const T1 = "#1A202C";
const T2 = "#4A5568";
const T3 = "#718096";
const WHITE = "#FFFFFF";
const STAR_COLOR = "#F6C90E";

const SIDEBAR_W = 248;
const MAX_STARS = 10;

// ── Report groups ─────────────────────────────────────────────────────────────
const REPORT_GROUPS = [
    {
        id: "ledger",
        header: "Account Reports",
        items: [
            { id: "general_ledger", label: "General Ledger", component: "LedgerDetails" },
            { id: "bankbook", label: "Bank Book", component: "LedgerDetails" },
            { id: "cashbook", label: "Cash Book", component: "LedgerDetails" },
            { id: "daybook", label: "Day Book", component: "LedgerDetails" },
            { id: "groupwise_summary", label: "Groupwise Summary", component: "LedgerDetails" },
            { id: "sale_vs_purchase", label: "Sale VS Purchase", component: "LedgerDetails" },
            { id: "inc_vs_exp",       label: "Inc. VS Exp.",     component: "LedgerDetails" },
            { id: "depreciation_report", label: "Depreciation Report", component: "DepreciationReport" },
            { id: "interest_calculation", label: "Interest Calculation", component: "InterestCalculationReport" },
            { id: "balance_sheet", label: "Balance Sheet", component: "BalanceSheetReport" },
        ],
    },
    {
        id: "stock",
        header: "Stock Reports",
        items: [
            { id: "general_stock", label: "General Stock Report", component: "StockReport" },
            { id: "average_rate", label: "Average Rate", component: "StockReport" },
            { id: "purchase_rate", label: "Purchase Rate", component: "StockReport" },
            { id: "last_purchase_rate", label: "Last Purchase Rate", component: "StockReport" },
            { id: "min_level", label: "Min Level", component: "StockReport" },
            { id: "max_level", label: "Max Level", component: "StockReport" },
            { id: "groupwise_item", label: "Groupwise Item", component: "StockReport" },
        ],
    },
    {
        id: "os_od_sale",
        header: "O/S & O/D Sale",
        items: [
            { id: "sale_outstanding", label: "Sale Outstanding Bills", component: "OSandODSaleReport" },
            { id: "sale_overdue", label: "Sale Overdue Bills", component: "OSandODSaleReport" },
        ],
    },
    {
        id: "os_od_purc",
        header: "O/S & O/D Purc",
        items: [
            { id: "purchase_outstanding", label: "Purchase Outstanding Bills", component: "OSandODPurcReport" },
            { id: "purchase_overdue", label: "Purchase Overdue Bills", component: "OSandODPurcReport" },
        ],
    },
    {
        id: "mis_sale",
        header: "MIS Sale Reports",
        items: [
            { id: "mis_itemwise_sale", label: "ItemWise Sales", component: "MISReports" },
            { id: "mis_partywise_itemwise_sale", label: "Partywise/Itemwise Sale", component: "MISReports" },
            { id: "mis_itemwise_partywise_sale", label: "Itemwise/Partywise Sale", component: "MISReports" },
            { id: "mis_citywise_itemwise_sale", label: "Citywise/Itemwise Sale", component: "MISReports" },
            { id: "mis_itemwise_citywise_sale", label: "Itemwise/Citywise Sale", component: "MISReports" },
            { id: "mis_agentwise_itemwise_sale", label: "Agentwise/Itemwise Sale", component: "MISReports" },
            { id: "mis_itemwise_agentwise_sale", label: "Itemwise/Agentwise Sale", component: "MISReports" },
            { id: "mis_partywise_citywise_sale", label: "Partywise/Citywise Sale", component: "MISReports" },
            { id: "mis_citywise_partywise_sale", label: "Citywise/Partywise Sale", component: "MISReports" },
            { id: "mis_monthly_sales_graph", label: "Monthly Sales Graph", component: "MISReports" },
        ],
    },
    {
        id: "mis_purchase",
        header: "MIS Purchase Reports",
        items: [
            { id: "mis_itemwise_purchase", label: "ItemWise Purchase", component: "MISPurchaseReports" },
            { id: "mis_partywise_itemwise_purchase", label: "Partywise/Itemwise Purchase", component: "MISPurchaseReports" },
            { id: "mis_itemwise_partywise_purchase", label: "Itemwise/Partywise Purchase", component: "MISPurchaseReports" },
            { id: "mis_citywise_itemwise_purchase", label: "Citywise/Itemwise Purchase", component: "MISPurchaseReports" },
            { id: "mis_itemwise_citywise_purchase", label: "Itemwise/Citywise Purchase", component: "MISPurchaseReports" },
            { id: "mis_agentwise_itemwise_purchase", label: "Agentwise/Itemwise Purchase", component: "MISPurchaseReports" },
            { id: "mis_itemwise_agentwise_purchase", label: "Itemwise/Agentwise Purchase", component: "MISPurchaseReports" },
            { id: "mis_partywise_citywise_purchase", label: "Partywise/Citywise Purchase", component: "MISPurchaseReports" },
            { id: "mis_citywise_partywise_purchase", label: "Citywise/Partywise Purchase", component: "MISPurchaseReports" },
            { id: "mis_monthly_purchase_graph", label: "Monthly Purchase Graph", component: "MISPurchaseReports" },
        ],
    },
    {
        id: "gst_reports",
        header: "GST Reports",
        items: [
            { id: "gstr1",  label: "GSTR-1",  component: "GSTReports" },
            { id: "gstr2b", label: "GSTR-2B", component: "GSTReports" },
            { id: "gstr3b", label: "GSTR-3B", component: "GSTReports" },
        ],
    },
];

// ── Map: sidebar item id → ReportType value used in each filter dialog ────────
// LedgerDetails dialog report type values
const LEDGER_REPORT_TYPE_MAP = {
    general_ledger: "general_ledger",
    bankbook: "bank_book",
    cashbook: "cash_book",
    daybook: "day_book",
    groupwise_summary: "group_wise_summary",
    sale_vs_purchase: "sale_vs_purchase",
    inc_vs_exp:       "inc_vs_exp",
};

// OS&OD Sale dialog report type values
const OS_OD_SALE_REPORT_TYPE_MAP = {
    sale_outstanding: "sale-outstanding",
    sale_overdue: "sale-overdue",
};

// OS&OD Purc dialog report type values
const OS_OD_PURC_REPORT_TYPE_MAP = {
    purchase_outstanding: "purchase-outstanding",
    purchase_overdue: "purchase-overdue",
};

// StockReport dialog report type values (must match StockReport's reportOptions)
const STOCK_REPORT_TYPE_MAP = {
    general_stock:      "General Stock Report",
    average_rate:       "Average Rate",
    purchase_rate:      "Purchase Rate",
    last_purchase_rate: "Last Purchase Rate",
    min_level:          "Min Level",
    max_level:          "Max Level",
    groupwise_item:     "Groupwise Item",
};

// GST dialog report type values
const GST_REPORT_TYPE_MAP = {
    gstr1:  "gstr1",
    gstr2b: "gstr2b",
    gstr3b: "gstr3b",
};

// Depreciation Report dialog report type values
const DEPRECIATION_REPORT_TYPE_MAP = {
    depreciation_report: "depreciation_report",
};

// Interest Calculation Report dialog report type values
const INTEREST_CALCULATION_REPORT_TYPE_MAP = {
    interest_calculation: "interest_calculation",
};

// MIS dialog report type values
const MIS_REPORT_TYPE_MAP = {
    mis_itemwise_sale: "itemwise_sale",
    mis_partywise_itemwise_sale: "partywise_itemwise_sale",
    mis_itemwise_partywise_sale: "itemwise_partywise_sale",
    mis_citywise_itemwise_sale: "citywise_itemwise_sale",
    mis_itemwise_citywise_sale: "itemwise_citywise_sale",
    mis_agentwise_itemwise_sale: "agentwise_itemwise_sale",
    mis_itemwise_agentwise_sale: "itemwise_agentwise_sale",
    mis_partywise_citywise_sale: "partywise_citywise_sale",
    mis_citywise_partywise_sale: "citywise_partywise_sale",
    mis_itemwise_purchase: "itemwise_purchase",
    mis_partywise_itemwise_purchase: "partywise_itemwise_purchase",
    mis_itemwise_partywise_purchase: "itemwise_partywise_purchase",
    mis_citywise_itemwise_purchase: "citywise_itemwise_purchase",
    mis_itemwise_citywise_purchase: "itemwise_citywise_purchase",
    mis_agentwise_itemwise_purchase: "agentwise_itemwise_purchase",
    mis_itemwise_agentwise_purchase: "itemwise_agentwise_purchase",
    mis_partywise_citywise_purchase: "partywise_citywise_purchase",
    mis_citywise_partywise_purchase: "citywise_partywise_purchase",
    mis_monthly_sales_graph: "monthly_sales_graph",
    mis_monthly_purchase_graph: "monthly_purchase_graph",
};

// ── Flat lookup map by ReportId (item.id) ─────────────────────────────────────
const ALL_ITEMS_MAP = {};
REPORT_GROUPS.forEach(g =>
    g.items.forEach(item => { ALL_ITEMS_MAP[item.id] = item; })
);

// Plan-based visibility: "Billing" plan only shows these report item ids;
// "Accounting" (or any other/unknown plan) shows every item, unchanged.
const BILLING_PLAN_REPORT_IDS = new Set([
    "general_ledger",
    "sale_outstanding",
    "sale_overdue",
    "gstr1",
]);

// ── Empty state ───────────────────────────────────────────────────────────────
function EmptyState() {
    return (
        <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 4, background: PAGE_BG }}>
            <Box sx={{ textAlign: "center", maxWidth: 380 }}>
                <Box sx={{ width: 64, height: 64, borderRadius: "16px", background: STEEL_LT, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                    <AssessmentOutlinedIcon sx={{ fontSize: 32, color: STEEL }} />
                </Box>
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: T1, mb: 1 }}>Select a Report</Typography>
                <Typography sx={{ fontSize: 13, color: T3, lineHeight: 1.7 }}>
                    Choose any report from the sidebar on the left to view it and configure its filters.
                </Typography>
            </Box>
        </Box>
    );
}

// ── Reusable Report Row ───────────────────────────────────────────────────────
function ReportRow({ item, isActive, isStarred, starLoading, onSelect, onToggleStar }) {
    return (
        <Box
            onClick={() => onSelect(item)}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                pl: 2,
                pr: 0.5,
                py: "7px",
                cursor: "pointer",
                background: isActive ? STEEL_LT : "transparent",
                borderLeft: `3px solid ${isActive ? STEEL : "transparent"}`,
                borderBottom: `1px solid ${BORDER}`,
                transition: "background 0.12s",
                "& .star-btn": {
                    opacity: isStarred ? 1 : 0,
                    transition: "opacity 0.15s",
                },
                "&:hover": {
                    background: isActive ? STEEL_LT : "#F1F5FF",
                    "& .star-btn": { opacity: 1 },
                },
            }}
        >
            <BarChartIcon sx={{ fontSize: 12, color: isActive ? STEEL : T3, flexShrink: 0 }} />
            <Typography
                sx={{
                    flex: 1,
                    fontSize: 12,
                    color: isActive ? STEEL : T2,
                    fontWeight: isActive ? 600 : 400,
                    lineHeight: 1.35,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {item.label}
            </Typography>
            <Tooltip
                title={isStarred ? "Remove from favourites" : "Add to favourites"}
                placement="right"
            >
                <Box
                    className="star-btn"
                    onClick={(e) => { e.stopPropagation(); onToggleStar(item); }}
                    sx={{
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 22,
                        height: 22,
                        borderRadius: "4px",
                        cursor: starLoading ? "not-allowed" : "pointer",
                        "&:hover": { background: "rgba(246,201,14,0.15)" },
                    }}
                >
                    {starLoading && isStarred === undefined ? (
                        <CircularProgress size={10} sx={{ color: T3 }} />
                    ) : isStarred ? (
                        <StarIcon sx={{ fontSize: 13, color: STAR_COLOR }} />
                    ) : (
                        <StarBorderIcon sx={{ fontSize: 13, color: T3 }} />
                    )}
                </Box>
            </Tooltip>
        </Box>
    );
}

// ── Main component ────────────────────────────────────────────────────────────
export default function AccountReports({
    connectionString,
    pdfString,
    // Optional: restrict which report groups are visible. When null, all groups show.
    groupFilter = null,
    // Optional: sidebar header title override
    title = "Account Reports",
}) {
    const API_URL = connectionString;
    const { user, selectedCompany } = useAuth();
    const CompID = selectedCompany?.CompId;
    const AppRegID = selectedCompany?.AppRegID || null;
    const userId = user.UserId;

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [activeReport, setActiveReport] = useState(null);

    // ── Favourites state ──────────────────────────────────────────────────────
    const [starredItems, setStarredItems] = useState([]);
    const [starLoading, setStarLoading] = useState(false);
    const [favLoading, setFavLoading] = useState(true);

    // Derived O(1) lookup by item.id (ReportId)
    const starredIds = new Set(starredItems.map(i => i.id));

    // ── Filter-open trigger counters (incrementing re-opens the dialog each click) ──
    const [ledgerOpenTrigger, setLedgerOpenTrigger]             = useState(0);
    const [stockOpenTrigger, setStockOpenTrigger]               = useState(0);
    const [osSaleOpenTrigger, setOsSaleOpenTrigger]             = useState(0);
    const [osPurcOpenTrigger, setOsPurcOpenTrigger]             = useState(0);
    const [misOpenTrigger, setMisOpenTrigger]                   = useState(0);
    const [misPurchaseOpenTrigger, setMisPurchaseOpenTrigger]   = useState(0);
    const [gstOpenTrigger, setGstOpenTrigger]                   = useState(0);
    const [depreciationOpenTrigger, setDepreciationOpenTrigger] = useState(0);
    const [interestCalcOpenTrigger, setInterestCalcOpenTrigger] = useState(0);
    const [balanceSheetOpenTrigger, setBalanceSheetOpenTrigger] = useState(0);

    // ── Pre-selected report type per component ────────────────────────────────
    const [ledgerReportType, setLedgerReportType]           = useState("general_ledger");
    const [stockReportType, setStockReportType]             = useState("General Stock Report");
    const [osSaleReportType, setOsSaleReportType]           = useState("sale-outstanding");
    const [osPurcReportType, setOsPurcReportType]           = useState("purchase-outstanding");
    const [misReportType, setMisReportType]                 = useState("itemwise_sale");
    const [misPurchaseReportType, setMisPurchaseReportType] = useState("itemwise_purchase");
    const [gstReportType, setGstReportType]                 = useState("gstr1");
    const [depreciationReportType, setDepreciationReportType] = useState("depreciation_report");
    const [interestCalcReportType, setInterestCalcReportType] = useState("interest_calculation");

    // ── Load favourites on mount ──────────────────────────────────────────────
    useEffect(() => {
        if (!userId || !CompID) {
            setFavLoading(false);
            return;
        }
        const params = new URLSearchParams({
            UserId: userId,
            CompID: CompID,
            AppRegID: AppRegID ?? 0,
        });
        fetch(`${API_URL}/api/getFavouriteReports?${params}`)
            .then(res => {
                if (!res.ok) throw new Error("Failed to load favourites");
                return res.json();
            })
            .then(({ success, data }) => {
                if (!success) throw new Error("API returned success: false");
                const items = (data || [])
                    .map(row => {
                        const found = ALL_ITEMS_MAP[row.ReportId];
                        if (!found) return null;
                        return { ...found, SrNo: row.SrNo };
                    })
                    .filter(Boolean)
                    .sort((a, b) => a.SrNo - b.SrNo);
                setStarredItems(items);
            })
            .catch((err) => { console.error("Load favourites error:", err); })
            .finally(() => setFavLoading(false));
    }, [API_URL, userId, CompID, AppRegID]);

    // ── Toggle star ───────────────────────────────────────────────────────────
    const toggleStar = useCallback(async (item) => {
        if (starLoading) return;
        const alreadyStarred = starredIds.has(item.id);
        if (!alreadyStarred && starredItems.length >= MAX_STARS) return;
        setStarLoading(true);
        try {
            const requestBody = {
                AppRegID: AppRegID ?? 0,
                CompID: CompID ?? 0,
                UserId: userId ?? 0,
                ReportId: item.id,
                ReportLabel: item.label,
            };
            console.log("Toggle star request:", { action: alreadyStarred ? "DELETE" : "ADD", body: requestBody });
            if (alreadyStarred) {
                const res = await fetch(`${API_URL}/api/deleteFavouriteReport`, {
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestBody),
                });
                const json = await res.json();
                if (!res.ok || !json.success) throw new Error(json.message || "Remove failed");
                setStarredItems(prev => prev.filter(i => i.id !== item.id));
            } else {
                const res = await fetch(`${API_URL}/api/addFavouriteReport`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestBody),
                });
                const json = await res.json();
                if (!res.ok || !json.success) throw new Error(json.message || "Add failed");
                setStarredItems(prev => [...prev, { ...item, SrNo: json.SrNo ?? prev.length + 1 }]);
            }
        } catch (err) {
            console.error("Toggle star error:", err);
        } finally {
            setStarLoading(false);
        }
    }, [API_URL, starLoading, starredIds, starredItems, userId, CompID, AppRegID]);

    // ── Handle sidebar item click ─────────────────────────────────────────────
    // Each component owns its own filter dialog. We just set the pre-selected
    // report type and increment the trigger counter; the component detects the
    // change via useEffect and opens its own filter dialog with real fetched data.
    const handleReportSelect = useCallback((item) => {
        setActiveReport(item);

        switch (item.component) {
            case "LedgerDetails": {
                const reportType = LEDGER_REPORT_TYPE_MAP[item.id] || "general_ledger";
                setLedgerReportType(reportType);
                setLedgerOpenTrigger(prev => prev + 1);
                break;
            }
            case "StockReport": {
                const reportType = STOCK_REPORT_TYPE_MAP[item.id] || "General Stock Report";
                setStockReportType(reportType);
                setStockOpenTrigger(prev => prev + 1);
                break;
            }
            case "OSandODSaleReport": {
                const reportType = OS_OD_SALE_REPORT_TYPE_MAP[item.id] || "sale-outstanding";
                setOsSaleReportType(reportType);
                setOsSaleOpenTrigger(prev => prev + 1);
                break;
            }
            case "OSandODPurcReport": {
                const reportType = OS_OD_PURC_REPORT_TYPE_MAP[item.id] || "purchase-outstanding";
                setOsPurcReportType(reportType);
                setOsPurcOpenTrigger(prev => prev + 1);
                break;
            }
            case "MISReports": {
                const reportType = MIS_REPORT_TYPE_MAP[item.id] || "itemwise_sale";
                setMisReportType(reportType);
                setMisOpenTrigger(prev => prev + 1);
                break;
            }
            case "MISPurchaseReports": {
                const reportType = MIS_REPORT_TYPE_MAP[item.id] || "itemwise_purchase";
                setMisPurchaseReportType(reportType);
                setMisPurchaseOpenTrigger(prev => prev + 1);
                break;
            }
            case "GSTReports": {
                const reportType = GST_REPORT_TYPE_MAP[item.id] || "gstr1";
                setGstReportType(reportType);
                setGstOpenTrigger(prev => prev + 1);
                break;
            }
            case "DepreciationReport": {
                const reportType = DEPRECIATION_REPORT_TYPE_MAP[item.id] || "depreciation_report";
                setDepreciationReportType(reportType);
                setDepreciationOpenTrigger(prev => prev + 1);
                break;
            }
            case "InterestCalculationReport": {
                const reportType = INTEREST_CALCULATION_REPORT_TYPE_MAP[item.id] || "interest_calculation";
                setInterestCalcReportType(reportType);
                setInterestCalcOpenTrigger(prev => prev + 1);
                break;
            }
            case "BalanceSheetReport": {
                // Clicking Balance Sheet again re-opens its filter popup (same trigger pattern as the other reports)
                setBalanceSheetOpenTrigger(prev => prev + 1);
                break;
            }
            default:
                break;
        }
    }, []);

    // ── Filter groups by plan, groupFilter prop, and search ───────────────────
    // "Billing" plan -> only General Ledger, Sale Outstanding/Overdue Bills,
    // GSTR-1. "Accounting" plan (or any other/unknown plan) -> every report,
    // unchanged.
    const planName = selectedCompany?.planName;
    // Case/space-insensitive match so "Billing", "billing", "BILLING " all count as the Billing plan
    const isBillingPlan = String(planName || "").trim().toLowerCase() === "billing";
    console.log("AccountReports planName:", planName, "| isBillingPlan:", isBillingPlan);
    const planFilteredGroups = isBillingPlan
        ? REPORT_GROUPS
            .map(g => ({ ...g, items: g.items.filter(item => BILLING_PLAN_REPORT_IDS.has(item.id)) }))
            .filter(g => g.items.length > 0)
        : REPORT_GROUPS;

    const activeGroups = groupFilter
        ? planFilteredGroups.filter(g => groupFilter.includes(g.id))
        : planFilteredGroups;

    const filteredGroups = searchText.trim()
        ? activeGroups
            .map(g => ({
                ...g,
                items: g.items.filter(item =>
                    item.label.toLowerCase().includes(searchText.toLowerCase())
                ),
            }))
            .filter(g => g.items.length > 0)
        : activeGroups;

    // ── Filter favourites by plan and search — all starred items visible
    // otherwise, but Billing-plan users never see an Accounting-only favourite ──
    const filteredFavourites = starredItems
        .filter(item => !isBillingPlan || BILLING_PLAN_REPORT_IDS.has(item.id))
        .filter(item => !searchText.trim() || item.label.toLowerCase().includes(searchText.toLowerCase()));

    // ── Render selected report content ────────────────────────────────────────
    const renderContent = () => {
        if (!activeReport) return <EmptyState />;
        const props = { connectionString, pdfString };
        switch (activeReport.component) {
            case "LedgerDetails":
                return (
                    <LedgerDetails
                        key="LedgerDetails"
                        {...props}
                        initialReportType={ledgerReportType}
                        openFilterTrigger={ledgerOpenTrigger}
                    />
                );
            case "StockReport":
                return (
                    <StockReport
                        key="StockReport"
                        {...props}
                        initialReportType={stockReportType}
                        openFilterTrigger={stockOpenTrigger}
                    />
                );
            case "OSandODSaleReport":
                return (
                    <OSandODSaleReport
                        key="OSandODSaleReport"
                        {...props}
                        initialReportType={osSaleReportType}
                        openFilterTrigger={osSaleOpenTrigger}
                    />
                );
            case "OSandODPurcReport":
                return (
                    <OSandODPurcReport
                        key="OSandODPurcReport"
                        {...props}
                        initialReportType={osPurcReportType}
                        openFilterTrigger={osPurcOpenTrigger}
                    />
                );
            case "MISReports":
                return (
                    <MISReports
                        key="MISReports"
                        {...props}
                        initialReportType={misReportType}
                        openFilterTrigger={misOpenTrigger}
                    />
                );
            case "MISPurchaseReports":
                return (
                    <MISPurchaseReports
                        key="MISPurchaseReports"
                        {...props}
                        initialReportType={misPurchaseReportType}
                        openFilterTrigger={misPurchaseOpenTrigger}
                    />
                );
            case "GSTReports":
                return (
                    <GSTReports
                        key="GSTReports"
                        {...props}
                        initialReportType={gstReportType}
                        openFilterTrigger={gstOpenTrigger}
                    />
                );
            case "DepreciationReport":
                return (
                    <DepreciationReport
                        key="DepreciationReport"
                        {...props}
                        initialReportType={depreciationReportType}
                        openFilterTrigger={depreciationOpenTrigger}
                    />
                );
            case "InterestCalculationReport":
                return (
                    <InterestCalculationReport
                        key="InterestCalculationReport"
                        {...props}
                        initialReportType={interestCalcReportType}
                        openFilterTrigger={interestCalcOpenTrigger}
                    />
                );
            case "BalanceSheetReport":
                return (
                    <BalanceSheetReport
                        key="BalanceSheetReport"
                        {...props}
                        openFilterTrigger={balanceSheetOpenTrigger}
                    />
                );
            default:
                return <EmptyState />;
        }
    };

    return (
        <Box sx={{ display: "flex", height: "93vh", maxHeight: "93vh", background: PAGE_BG, overflow: "hidden" }}>

            {/* ── SIDEBAR WRAPPER ── */}
            <Box sx={{ position: "relative", flexShrink: 0, overflow: "visible", zIndex: 10, height: "100%", display: "flex", flexDirection: "column" }}>

                {/* ── Sidebar panel ── */}
                <Box sx={{ width: sidebarOpen ? SIDEBAR_W : 0, height: "100%", background: CARD, borderRight: `1px solid ${BORDER}`, display: "flex", flexDirection: "column", overflow: "hidden", transition: "width 0.22s ease" }}>

                    {/* Fixed header */}
                    <Box sx={{ background: NAVY, px: 2, pt: 1.5, pb: 1.5, flexShrink: 0 }}>
                        <Typography sx={{ fontSize: 12, fontWeight: 700, color: WHITE, mb: 1, letterSpacing: ".5px", textTransform: "uppercase" }}>
                            {title}
                        </Typography>
                        <TextField
                            size="small" fullWidth placeholder="Search reports…"
                            value={searchText} onChange={(e) => setSearchText(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.45)" }} />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    background: "rgba(255,255,255,0.08)", borderRadius: "4px", fontSize: 12, color: WHITE, height: 30,
                                    "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
                                    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
                                    "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,0.55)", borderWidth: 1 },
                                    "& input": { py: 0 },
                                    "& input::placeholder": { color: "rgba(255,255,255,0.4)", opacity: 1 },
                                },
                            }}
                        />
                    </Box>

                    {/* ── Scrollable list ── */}
                    <Box
                        sx={{
                            flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden",
                            "&::-webkit-scrollbar": { width: 4 },
                            "&::-webkit-scrollbar-track": { background: "transparent" },
                            "&::-webkit-scrollbar-thumb": { background: BORDER, borderRadius: 4 },
                            "&::-webkit-scrollbar-thumb:hover": { background: T3 },
                        }}
                    >
                        {favLoading && (
                            <Box sx={{ px: 2, py: 2, display: "flex", alignItems: "center", gap: 1 }}>
                                <CircularProgress size={12} sx={{ color: STAR_COLOR }} />
                                <Typography sx={{ fontSize: 11, color: T3 }}>Loading favourites…</Typography>
                            </Box>
                        )}

                        {/* ── FAVOURITES SECTION ── */}
                        {!favLoading && filteredFavourites.length > 0 && (
                            <Box>
                                <Box sx={{ px: 1.5, py: "6px", background: FAV_BG, borderBottom: `1px solid ${FAV_BORD}`, userSelect: "none", display: "flex", alignItems: "center", gap: 0.5 }}>
                                    <StarIcon sx={{ fontSize: 10, color: STAR_COLOR }} />
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#B8860B", textTransform: "uppercase", letterSpacing: ".8px" }}>
                                        Favourites
                                        <Box component="span" sx={{ ml: 0.8, px: "5px", py: "1px", fontSize: 9, fontWeight: 700, background: STAR_COLOR, color: NAVY, borderRadius: "8px", verticalAlign: "middle" }}>
                                            {starredItems.length}/{MAX_STARS}
                                        </Box>
                                    </Typography>
                                </Box>
                                {filteredFavourites.map(item => (
                                    <ReportRow
                                        key={`fav-${item.id}`}
                                        item={item}
                                        isActive={activeReport?.id === item.id}
                                        isStarred={true}
                                        starLoading={starLoading}
                                        onSelect={handleReportSelect}
                                        onToggleStar={toggleStar}
                                    />
                                ))}
                                <Box sx={{ height: 4, background: FAV_BG, borderBottom: `1px solid ${FAV_BORD}` }} />
                            </Box>
                        )}

                        {/* ── REGULAR REPORT GROUPS ── */}
                        {filteredGroups.map((group, gIdx) => (
                            <Box key={group.id}>
                                <Box sx={{ px: 1.5, py: "6px", background: TH_BG, borderBottom: `1px solid ${BORDER}`, borderTop: gIdx === 0 && filteredFavourites.length === 0 ? "none" : `1px solid ${BORDER}`, userSelect: "none" }}>
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: STEEL, textTransform: "uppercase", letterSpacing: ".8px" }}>
                                        {group.header}
                                    </Typography>
                                </Box>
                                {group.items.map(item => (
                                    <ReportRow
                                        key={item.id}
                                        item={item}
                                        isActive={activeReport?.id === item.id}
                                        isStarred={starredIds.has(item.id)}
                                        starLoading={starLoading}
                                        onSelect={handleReportSelect}
                                        onToggleStar={toggleStar}
                                    />
                                ))}
                            </Box>
                        ))}

                        {!favLoading && filteredGroups.length === 0 && filteredFavourites.length === 0 && (
                            <Box sx={{ px: 2, py: 3, textAlign: "center" }}>
                                <SearchIcon sx={{ fontSize: 22, color: BORDER, display: "block", mx: "auto", mb: 0.5 }} />
                                <Typography sx={{ fontSize: 12, color: T3 }}>No reports found</Typography>
                            </Box>
                        )}
                    </Box>
                </Box>

                {/* ── TOGGLE TAB ── */}
                <Tooltip title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"} placement="right">
                    <Box onClick={() => setSidebarOpen(v => !v)}
                        sx={{ position: "absolute", right: -14, top: "50%", transform: "translateY(-50%)", width: 14, height: 52, background: NAVY, borderRadius: "0 6px 6px 0", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 30, boxShadow: "2px 2px 6px rgba(0,0,0,0.18)", transition: "background 0.14s", "&:hover": { background: STEEL } }}>
                        {sidebarOpen ? <ChevronLeftIcon sx={{ fontSize: 13, color: WHITE }} /> : <ChevronRightIcon sx={{ fontSize: 13, color: WHITE }} />}
                    </Box>
                </Tooltip>
            </Box>

            {/* ── MAIN CONTENT AREA ── */}
            <Box sx={{
                flex: 1, minWidth: 0, minHeight: 0,
                display: "flex", flexDirection: "column",
                overflowY: "auto", overflowX: "hidden",
                "&::-webkit-scrollbar": { width: 6 },
                "&::-webkit-scrollbar-track": { background: "transparent" },
                "&::-webkit-scrollbar-thumb": { background: BORDER, borderRadius: 4 },
                "&::-webkit-scrollbar-thumb:hover": { background: T3 },
            }}>
                {renderContent()}
            </Box>

        </Box>
    );
}